module.exports = __webpack_public_path__ + "images/BUS.c6442baf7e2b811af6ece985a197047f.png";